{
    "menu": [
        {
            "label": "Help menu",
            "items": [
                { "slug": "index", "label": "Getting started" },
                { "slug": "markdown", "label": "Markdown" }
            ]
        },
        {
            "label": "Function",
            "items": [
                { "slug": "schema", "label": "Schema and Mapping"}
            ]
        }
    ]
}
